import React, { useEffect, useState } from 'react';
import { TableContainer, TableHead, TableRow, Checkbox, FormControlLabel, TextField, Paper, Card, Switch, CircularProgress } from '@mui/material';
import SoftButton from "components/SoftButton";
import SoftInput from 'components/SoftInput';
import SoftBox from 'components/SoftBox';
import { baseURL } from 'utils/api';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import SoftTypography from 'components/SoftTypography';

const HoursOfOperation = ({ data, id }) => {

  const [hours, setHours] = useState([
    { day: 'Sunday', openingHours: '', closingHours: '', isSplit: false, isOpen: false, isClosed: false, isSplitHours: false, secondOpeningHours: '', secondClosingHours: '' },
    { day: 'Monday', openingHours: '', closingHours: '', isSplit: false, isOpen: false, isClosed: false, isSplitHours: false, secondOpeningHours: '', secondClosingHours: '' },
    { day: 'Tuesday', openingHours: '', closingHours: '', isSplit: false, isOpen: false, isClosed: false, isSplitHours: false, secondOpeningHours: '', secondClosingHours: '' },
    { day: 'Wednesday', openingHours: '', closingHours: '', isSplit: false, isOpen: false, isClosed: false, isSplitHours: false, secondOpeningHours: '', secondClosingHours: '' },
    { day: 'Thursday', openingHours: '', closingHours: '', isSplit: false, isOpen: false, isClosed: false, isSplitHours: false, secondOpeningHours: '', secondClosingHours: '' },
    { day: 'Friday', openingHours: '', closingHours: '', isSplit: false, isOpen: false, isClosed: false, isSplitHours: false, secondOpeningHours: '', secondClosingHours: '' },
    { day: 'Saturday', openingHours: '', closingHours: '', isSplit: false, isOpen: false, isClosed: false, isSplitHours: false, secondOpeningHours: '', secondClosingHours: '' }
  ]);


  const [madeChanges, setMadeChanges] = useState(false);
  const [loading, setLoading] = useState(false);
  const userTheme = useSelector((state) => state.commonSlice.theme);

  useEffect(() => {
    if (data && data.length > 0) {
      setHours(data);
    }
  }, [data]);


  const handleCheckboxChange = (i) => {
    setMadeChanges(true);
    if (hours[i].openingHours == '' && hours[i].closingHours == '') {
      setHours([...hours], hours[i].openingHours = '09:00 AM', hours[i].closingHours = '05:00 PM', hours[i].isOpen = true)
    } else {
      setHours([...hours], hours[i].openingHours = '', hours[i].isOpen = false, hours[i].isSplit = false, hours[i].closingHours = '', hours[i].secondOpeningHours = '', hours[i].secondClosingHours = '');
    }
  };

  const convertToAmPm = (time) => {

    let [hours, minutes] = time.split(':'); // Properly split hours and minutes
    hours = parseInt(hours, 10);
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert 0 to 12 for 12 AM
    const formattedHours = hours < 10 ? `0${hours}` : `${hours}`;
    const formattedMinutes = minutes.padStart(2, '0'); // Ensure minutes have leading zero
    return `${formattedHours}:${formattedMinutes} ${ampm}`;
  };

  const convertAmPmTo24 = (time) => {
    const [timePart, meridiem] = time.split(' '); // Split time and AM/PM 
    let [hours, minutes] = timePart.split(':'); // Properly split hours and minutes 
    hours = parseInt(hours, 10);
    minutes = parseInt(minutes, 10); // Ensure minutes is an integer

    if (meridiem === 'PM' && hours < 12) hours += 12; // Convert 12-hour time to 24-hour time
    if (meridiem === 'AM' && hours === 12) hours = 0; // Convert 12 AM to 0 hours

    const formattedHours = hours < 10 ? `0${hours}` : `${hours}`;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`; // Add leading zero if needed

    return `${formattedHours}:${formattedMinutes}`;
  };



  const handleTimeChange = (i, type, value) => {
    setMadeChanges(true);
    const convertedValue = convertToAmPm(value);
    if (type == 'from') {
      setHours([...hours], hours[i].openingHours = convertedValue);
    } else {
      setHours([...hours], hours[i].closingHours = convertedValue);
    }
  };

  const handleSplitHoursTimeChange = (i, type, value) => {
    setMadeChanges(true);
    const convertedValue = convertToAmPm(value);
    if (type == 'from') {
      setHours([...hours], hours[i].secondOpeningHours = convertedValue);
    } else {
      setHours([...hours], hours[i].secondClosingHours = convertedValue);
    }
  };


  const handleChangeSplitHours = (i) => {
    setMadeChanges(true);
    if (hours[i].secondOpeningHours == '' && hours[i].secondClosingHours == '') {
      setHours([...hours], hours[i].secondOpeningHours = '09:00 AM', hours[i].secondClosingHours = '05:00 PM', hours[i].isSplit = true)
    } else {
      setHours([...hours], hours[i].secondOpeningHours = '', hours[i].secondClosingHours = '', hours[i].isSplit = false);
    }
  }

  const handleUpdate = (e) => {
    e.preventDefault();
    setLoading(true);



    fetch(`${baseURL}updateBusiness/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        operatingHours: hours
      })
    })
      .then(res => res.json())
      .then(data => {
        setLoading(false);
        if (data.success) {
          toast.success(data.message)
        } else {
          toast.error(data.message)
        }
      }
      ).catch(err => {
        setLoading(false);
        toast.error(err.message || 'Something went wrong');
      });
  }


  return (
    <>
      <SoftBox>
        {hours && hours.length > 0 && hours.map((elm, i) => (
          <>
            <SoftBox
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: 1,
                borderBottom: "1px solid #f0f0f0",
                width: 800
              }}
              gap={2}
            >
              <SoftTypography
                variant="caption"
                sx={{ width: 160, fontSize: '14px' }}
              >{elm?.day.charAt(0).toUpperCase() + elm?.day.slice(1)}</SoftTypography>
              <SoftBox>

                <SoftBox
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >

                  <SoftBox
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 260
                    }}
                  >
                    <SoftBox mr={2}  >
                      <SoftInput
                        label="From"
                        type="time"
                        disabled={elm?.closingHours == '' && elm?.openingHours == ''}
                        value={convertAmPmTo24(elm?.openingHours)}
                        onChange={(e) => handleTimeChange(i, 'from', e.target.value)}
                        inputProps={{ step: 300 }} // 5 minutes
                        InputLabelProps={{ shrink: true }}
                      />
                    </SoftBox>
                    <SoftBox  >
                      <SoftInput
                        label="To"
                        type="time"
                        disabled={elm?.closingHours == '' && elm?.openingHours == ''}
                        value={convertAmPmTo24(elm?.closingHours)}
                        onChange={(e) => handleTimeChange(i, 'to', e.target.value)}
                        inputProps={{ step: 300 }}
                        InputLabelProps={{ shrink: true }}
                      />
                    </SoftBox>
                  </SoftBox>
                </SoftBox>

                {
                  elm?.secondOpeningHours != '' && elm?.secondClosingHours != '' && (
                    <SoftBox
                      mt={1}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 260
                      }}
                    >
                      <SoftBox mr={2}  >
                        <SoftInput
                          label="From"
                          type="time"
                          value={convertAmPmTo24(elm?.secondOpeningHours)}
                          onChange={(e) => handleSplitHoursTimeChange(i, 'from', e.target.value)}
                          inputProps={{ step: 300 }} // 5 minutes
                          InputLabelProps={{ shrink: true }}
                        />
                      </SoftBox>
                      <SoftBox>
                        <SoftInput
                          label="To"
                          type="time"
                          value={convertAmPmTo24(elm?.secondClosingHours)}
                          onChange={(e) => handleSplitHoursTimeChange(i, 'to', e.target.value)}
                          inputProps={{ step: 300 }}
                          InputLabelProps={{ shrink: true }}
                        />
                      </SoftBox>

                    </SoftBox>
                  )
                }
              </SoftBox>
              <SoftBox
                sx={{
                  width: 160
                }}
              >
                <FormControlLabel
                  control={
                    <Switch
                      checked={elm.isOpen}
                      onChange={() => handleCheckboxChange(i)}
                    />
                  }
                  label={elm.isOpen ? 'Open' : 'Closed'}
                  sx={{
                    '& .MuiFormControlLabel-label': {
                      color: userTheme === 'dark' ? '#ffffff' : '#000000',
                    },
                  }}
                />
              </SoftBox>

              <SoftBox
                sx={{
                  width: 200
                }}
              >
                <FormControlLabel
                  control={
                    <Switch
                      disabled={!elm.isOpen}
                      checked={elm?.secondOpeningHours != '' && elm?.secondClosingHours}
                      onChange={() => handleChangeSplitHours(i)}
                    />
                  }
                  label="Split Hours"
                  sx={{
                    '& .MuiFormControlLabel-label': {
                      color: userTheme === 'dark' ? '#ffffff !important' : '#000000 !important', // Dynamic label color
                    },
                  }}
                />
              </SoftBox>



            </SoftBox>
            {/* </TableRow> */}
          </>
        ))}

      </SoftBox>

      <SoftBox
        m={2}
        display="flex"
        gap={2}

      >

        <SoftButton
          fullWidth variant="gradient"
          color={madeChanges ? "info" : "light"}
          disabled={!madeChanges}
          sx={{ marginTop: 2, marginRight: 2 }}
          onClick={handleUpdate}
        >
          {
            loading ? <CircularProgress size={24} color='white' /> : 'Save Changes'
          }
        </SoftButton>

      </SoftBox>


    </>
  );
};

export default HoursOfOperation;
